import { isTicketNotification, buildTicketNotificationOpenUrl } from "./ticketNotificationOpen";

export const getNotificationRoute = (notification) => {
  const toLower = (value) => String(value || "").trim().toLowerCase();
  const referenceType = toLower(notification?.reference_type);
  const nestedData =
    notification?.data && typeof notification.data === "object"
      ? notification.data
      : {};
  const type = toLower(notification?.type || nestedData?.type);
  const title = toLower(notification?.title);
  const message = toLower(notification?.message || notification?.content || notification?.body);
  const referenceId = notification?.reference_id;
  const chatGroupId =
    notification?.chat_group_id || nestedData?.chat_group_id ||
    (["chat_message", "chat_group_invite"].includes(referenceType) ? referenceId : null);
  const equipmentId =
    notification?.equipment_id ||
    notification?.equipmentId ||
    nestedData?.equipment_id ||
    nestedData?.equipmentId ||
    referenceId;
  const processId =
    notification?.process_id ||
    notification?.processId ||
    nestedData?.process_id ||
    nestedData?.processId;
  const isProcessReminder =
    type === "process_reminder" ||
    title === "process reminder" ||
    message.includes("scheduled today");

  if (["chat_message", "chat_group_invite"].includes(type) ||
      ["chat_message", "chat_group_invite"].includes(referenceType)) {
    return chatGroupId
      ? `/group-chat?group=${encodeURIComponent(String(chatGroupId))}`
      : "/group-chat";
  }

  if (isProcessReminder && referenceId) {
    return `/task-list?project_id=${encodeURIComponent(String(referenceId))}`;
  }

  if (isTicketNotification(notification)) {
    return buildTicketNotificationOpenUrl(notification);
  }

  if (referenceType === "admin_note" && equipmentId) {
    return `/equipment-details/${equipmentId}`;
  }

  if (
    ["equipment_on_hold", "equipment_hold_released"].includes(type) &&
    equipmentId
  ) {
    return `/equipment-details/${encodeURIComponent(String(equipmentId))}`;
  }

  if (referenceType === "equipment_process" && equipmentId) {
    const params = new URLSearchParams();
    if (processId || referenceId) {
      params.set("process_id", String(processId || referenceId));
    }
    const query = params.toString();
    return query
      ? `/equipment-details/${equipmentId}?${query}`
      : `/equipment-details/${equipmentId}`;
  }

  // Ready-to-finish (Step 2): deep-link to the equipment, focusing the process.
  if (type === "process_ready_to_end" && equipmentId) {
    const params = new URLSearchParams();
    if (processId || referenceId) {
      params.set("process_id", String(processId || referenceId));
    }
    params.set("action", notification?.action || "End");
    return `/equipment-details/${equipmentId}?${params.toString()}`;
  }

  const isEquipmentNotification =
    referenceType === "equipment" ||
    type === "equipment" ||
    title.includes("admin note") ||
    message.includes("admin note");

  if (isEquipmentNotification && equipmentId) {
    const isAdminNote = type === "admin_note" || referenceType === "admin_note";
    if (isAdminNote) {
      return `/equipment-details/${equipmentId}`;
    }
    const params = new URLSearchParams();
    if (processId) params.set("process_id", String(processId));
    const query = params.toString();
    return query
      ? `/equipment-details/${equipmentId}?${query}`
      : `/equipment-details/${equipmentId}`;
  }

  return null;
};
